export const TabletIcon = () => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 34H34V38H18V34ZM18 24H42V28H18V24ZM18 44H28V48H18V44Z" fill="url(#paint0_linear_971_23785)"/>
            <path
                d="M47.9091 8H41.7727V6C41.7727 4.93913 41.3417 3.92172 40.5745 3.17157C39.8073 2.42143 38.7668 2 37.6818 2H21.3182C20.2332 2 19.1927 2.42143 18.4255 3.17157C17.6583 3.92172 17.2273 4.93913 17.2273 6V8H11.0909C10.0059 8 8.96539 8.42143 8.1982 9.17157C7.43101 9.92172 7 10.9391 7 12V54C7 55.0609 7.43101 56.0783 8.1982 56.8284C8.96539 57.5786 10.0059 58 11.0909 58H47.9091C48.9941 58 50.0346 57.5786 50.8018 56.8284C51.569 56.0783 52 55.0609 52 54V12C52 10.9391 51.569 9.92172 50.8018 9.17157C50.0346 8.42143 48.9941 8 47.9091 8ZM21.3182 6H37.6818V14H21.3182V6ZM47.9091 54H11.0909V12H17.2273V18H41.7727V12H47.9091V54Z"
                fill="url(#paint1_linear_971_23785)"/>
            <defs>
                <linearGradient id="paint0_linear_971_23785" x1="31.6552" y1="10.5882" x2="64.5541" y2="61.9579"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
                <linearGradient id="paint1_linear_971_23785" x1="32.6034" y1="-29.2941" x2="114.986" y2="74.0735"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
            </defs>
        </svg>
    );
};